import { Banner } from '../banner/Banner';

const bannerContent = {
    header: 'Roomservice, sa du?',
    text: 'Nå er det enda enklere å finne drømmehotellet på FINN reise.',
    callToAction: 'Prøv da vel!',
    link: 'https://www.finn.no/reise/artikler/na-blir-det-enda-enklere-a-finne-drommehotellet-pa-finn-reise',
    img: {
        src: 'https://images.finncdn.no/dynamic/1600w/travel/frontpage/article/gutt_hopper_i_hotellseng?format=auto&fit=crop&width=470&height=300',
        width: 470,
        height: 300,
        alt: '',
    },
};

export const FrontpageBanner = () => {
    const { header, text, callToAction, link, img } = bannerContent;

    return <Banner header={header} text={text} callToAction={callToAction} link={link} imgType="img" img={img} />;
};
